import { useMemo } from 'react'

const EMPTY_ASSET_IDS = Object.freeze([])

export const useHomeCombinedAssetIds = ({
  marketCapData,
  signalExchanges,
  enabled = true
} = {}) => {
  return useMemo(() => {
    if (!enabled) return EMPTY_ASSET_IDS

    const marketCapAssetIds = (marketCapData ?? []).map((marketCapItem) =>
      String(marketCapItem.assetId)
    )

    const signalAssetIds = Object.values(signalExchanges ?? {})
      .flat()
      .map((signal) => String(signal.assetId))

    const combinedAssetIds = [...new Set([...marketCapAssetIds, ...signalAssetIds])]

    if (!combinedAssetIds.length) return EMPTY_ASSET_IDS

    return combinedAssetIds.sort((a, b) => Number(a) - Number(b))
  }, [enabled, marketCapData, signalExchanges])
}
